<div class="not-allowed-container">
    <app-empty-state illustration="access">
        <a class="btn-secondary" [routerLink]="'/tasks'">Go Home</a>
    </app-empty-state>
</div>
